import type { ReactNode } from 'react';
import { Toolbar } from '@devexpress/dx-react-grid-bootstrap4';

export interface DataTableToolbarProps {
  /** Всего записей (для подписи «Найдено записей: …»). */
  dataLength?: number;
  currentPage?: number;
  pageSize?: number;
  children?: ReactNode;
}

const DataTableToolbar = (props: DataTableToolbarProps) => {
  const { dataLength, currentPage, pageSize, children } = props;
  const fromRow = currentPage * pageSize + 1;
  const toRow = (currentPage + 1) * pageSize;

  return (
    <Toolbar.Root style={ { backgroundColor: 'initial' } } className='row'>
      { !!dataLength && (
        <span>
          Найдено записей: { dataLength },&nbsp;
          показано с { fromRow } по { toRow > dataLength ? dataLength : toRow }
        </span>
      ) }

      { children }
    </Toolbar.Root>
  );
};

export default DataTableToolbar;
